<template>
  <div class="dashboard live-tracking-group">
    <v-gallery :images="images" :index="index" @close="index = null" />
    <v-container class="pa-0">
      <v-overlay :value="overlay">
        <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <GmapMap :center="center" :zoom="zoom" map-type-id="terrain" style="height:100vh; " :options="{
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          styles: this.mapStyle,
        }">
        <GmapCluster :maxZoom="15" :zoomOnClick="true" v-if="userBeing">
          <gmap-custom-marker v-for="(data, index) in userBeing.data.records[0].data_live_trackings" :key="index"
            :marker="{ lat: data.latitude, lng: data.longitude }"
            @click.native="toggleInfo(data, index, countDistance(data))">
            <div v-if="countDistance(data) == true"
              :class="inarea == 'all' || inarea == 'inarea' ? 'in-area-circle-true' : 'display-none'">
            </div>
            <div v-else :class="inarea == 'all' || inarea == 'outarea' ? 'in-area-circle-false' : 'display-none'">
            </div>
          </gmap-custom-marker>

          <!-- <gmap-custom-marker v-for="data in staffList" :key="data.id" :marker="{ lat: data.lat, lng: data.lng }"
            :clickable="true" @click.native="toggleInfo(data, data.id)">
            <v-avatar class="mx-2" v-if="data.face_url == null"></v-avatar>
            <v-avatar size="40" class="mx-2" v-else>
              <img style="cursor: pointer;" :src=" data.face_url != null && data.face_url != '-'
                      ? data.face_url
                      : 'img/neutral.svg'" alt="Avatar" class="portrait" />
            </v-avatar>
          </gmap-custom-marker> -->

          <GmapInfoWindow :options="info_options" :position="info_position" :opened="info_opened"
            @closeclick="onCloseIW">
            <center>
              <div class="v-avatar mr-1" style="height: 48px; min-width: 48px; width: 48px;"
                :style="markerArea ? 'border: 3px solid #4399D4' : 'border: 3px solid #E64A4D'">
                <img v-if="user_full_detail.avatar_url" :src="user_full_detail.avatar_url" alt="Avatar">
                <img v-else src="/img/neutral.png">
              </div>
              <span v-if="info_position" class="mx-2" :style="markerArea ? 'color: #1976D2;' : 'color: #E64A4D'"
                style="font-size: 16px; font-weight: 600; line-height: 48px;">
                <v-icon class="mr-2" :style="markerArea ? 'color: #1976D2;' : 'color: #E64A4D'">mdi-av-timer</v-icon>
                <strong>{{milisToHour(info_timestamp)}} {{checkTimeZone(user_full_detail.group.timezone)}}</strong>
              </span>
            </center>
          </GmapInfoWindow>
        </GmapCluster>
        <GmapCircle v-for="(pin, index) in markersCircle" :key="index"
          :center="{ lat: pin.lat_zone, lng: pin.lng_zone }" :radius="pin.radius" :visible="true" :options="{
            fillColor: '#1976D2',
            fillOpacity: 0.1,
            strokeColor: '#1976D2',
            strokeOpacity: 0,
            strokeWeight: 2
          }"></GmapCircle>
      </GmapMap>

    </v-container>
    <div style="position: absolute; top: 100px; left: 0;">
      <v-card style="position: relative; height: 112px; margin-left: 40px; width: 49vw;" class="px-3">
        <div>
          <!-- 
           
            </v-row> -->
          <v-row class="pa-4" style="align-items: center;">
            <!-- <v-col md="3" xl="2">
              <v-row class="pa-0 ma-0">
                <v-col class="pa-0 ma-0 mt-n7">
                  <v-btn class="px-2 py-5"
                    style="text-transform: capitalize !important; border: 1px solid #C4C4C4; font-weight: bold; min-width: 120px; height: 48px;"
                    outlined @click="showTree('group')">
                    <div style="display: flex; justify-content: space-evenly; width: 100%; align-item: center;">
                      <v-icon style="font-size: 12px; font-weight: bold; color: #858585 !important;">mdi-triangle
                        {{!showTreeView ? 'mdi-rotate-180' : ''}}
                      </v-icon>
                      <v-icon class="mx-2" style="font-size: 16px; font-weight: bold; color: #858585 !important;">
                        {{!showTreeView ? "mdi-folder" : "mdi-folder-open"}}
                      </v-icon>
                      <span>{{$t('group')}} </span>
                    </div>
                  </v-btn>
                </v-col>
              </v-row>
              <v-card style="max-width: 350px !important" light class="fix sae-dropdown mt-12" v-if="showTreeView">
                <v-treeview absolute hoverable :items="groupList" transition :selectable="true"
                  :search="searchGroupsByTree" selection-type="independent" v-model="selectedGroups">
                  <template v-slot:label="{ item, open, selected }">
                    <div style="cursor: pointer" @click="checkSearchValue(item.id)">
                      <span>{{ item.name }}</span>
                    </div>
                  </template>
                </v-treeview>
              </v-card>
            </v-col> -->
            <v-col md="4" xl="3" class="mt-n4">
              <v-combobox :label="$t('group')" :items="groupList" v-model="selectedGroups" item-text="name"
                item-value="value"></v-combobox>
            </v-col>

            <v-col md="4" xl="3">
              <v-row class="pa-4 calendar-pointer"
                style="align-items: center; flex-direction: column; justify-content: center; ">
                <v-col md="12" class="pa-0 ma-0">
                  <v-menu style="box-shadow: none;" ref="menu" v-model="menuStart" :close-on-content-click="false"
                    transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field :value="dateFormatted(startDate)" solo prepend-inner-icon="mdi-calendar" readonly
                        v-on="on" color="primary"></v-text-field>
                    </template>
                    <v-date-picker v-model="startDate" @change="onStartDateChange" no-title scrollable
                      :locale="$t('locale')" show-current="false"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>

            <v-col md="4" xl="6" class="mt-n8 live-tracking">
              <v-autocomplete class="live-tracking" clearable v-model="userId" :label="$t('find_user') + ' ...'"
                prepend-inner-icon="mdi-magnify" @change="findTrackingUser($event)"
                @click:clear="calculateFilteredSummary(null)" single-line hide-details :items="userList" hide-no-data
                hide-selected item-value="id" item-text="full_name" return-object :loading="findUserButton">
                <template v-slot:item="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-item-content v-text="data.item"></v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-avatar>
                      <img v-if="data.item.avatar_url" :src="data.item.avatar_url">
                      <img v-else src="/img/neutral.png">
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-html="data.item.full_name"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </div>

    <div style="position: absolute; top: 100px; max-height: 84vh;  left: calc(49vw + 80px)">
      <v-card style="position: relative; width: 25vw; min-height: 114px;" class="individual-card px-3">
        <v-row v-if="!userBeing && !noTracking"
          style="flex-direction: column; height: 114px; justify-content: center; align-items: center;">
          <v-col class="pa-10">
            <b style="font-size: 24px;">Group</b>
          </v-col>
        </v-row>
        <div v-if="!userBeing && selectedGroups && !noTracking">
          <v-divider style="padding-top: 24px;"></v-divider>
        </div>
        <v-row v-if="!userBeing && selectedGroups && !noTracking"
          style="flex-direction: column; justify-content: center;" class="px-10 pt-4 pb-4">
          <b style="font-size: 20px;" class="mb-4">{{selectedGroups.name}}</b>
          <div style="max-height: 60vh;" class="group-overflow overflow-y-auto overflow-x-hidden">
            <v-row class="pa-2 py-2 my-2" style="align-items: center; cursor: pointer;" v-for="(i, index) in userList"
              :key="index" @click="findTrackingUser(i)">

              <div class="v-avatar ml-1" style="height: 60px; min-width: 60px; width: 60px;">
                <img v-if="i.avatar_url" :src="i.avatar_url" alt="Avatar">
                <img v-else src="/img/neutral.png">
              </div>
              <div class="ml-4"
                style="font-size: 16px; font-weight: bold; line-height: 26px; letter-spacing: 0px; color:#background: #040404;">
                {{i.full_name}}
                <br>
                <span
                  style="font-family: Noto Sans; font-size: 14px; font-weight: 400; line-height: 23px; letter-spacing: 0px; color: #686868;">
                  {{i.job_position}}</span>
              </div>
              <div style="margin-left: auto;">
                <img style="margin-right: 40px;" src="/img/vector-right.svg">
              </div>

            </v-row>
          </div>
        </v-row>
        <div v-if="userBeing">
          <v-row class="pa-10 pb-4">
            <img @click="backtoGroup()" style="margin-right: 19px; cursor: pointer;"
              src="/img/vector-arrow-left.svg"><b>Employee Details</b>
          </v-row>
          <v-row class="pl-10 py-3" style="align-items: center;">
            <div class="v-avatar ml-1" style="height: 60px; min-width: 60px; width: 60px;">
              <img v-if="user_full_detail.avatar_url" :src="user_full_detail.avatar_url" alt="Avatar">
              <img v-else src="/img/neutral.png">
            </div>
            <div class="ml-4"
              style="font-size: 16px; font-weight: bold; line-height: 26px; letter-spacing: 0px; color:#background: #040404;">
              {{user_full_detail.full_name}}
              <br>
              <span
                style="font-family: Noto Sans; font-size: 14px; font-weight: 400; line-height: 23px; letter-spacing: 0px; color: #686868;">
                {{user_full_detail.job_position}}</span>
            </div>
          </v-row>
          <v-row class="ml-1">
            <v-col sm="5" md="4" lg="4" xl="3" class="mr-5">
              <v-btn class="px-4 py-3"
                style="text-transform: capitalize !important; border: 1px solid #C4C4C4; height: 48px; font-weight: bold; min-width: 120px;"
                @click="showTree('status-out')" :outlined="!filterToggler" :color="colorToggler">
                <div v-if="filterToggler"
                  style="display: flex; justify-content: space-evenly; width: 100%; align-item: center;">
                  <v-icon style="font-size: 16px; font-weight: bold; color: #ffffff !important;">mdi-filter-variant
                  </v-icon>
                  <span class="mx-2">Filter</span>
                  <v-icon style="font-size: 12px; font-weight: bold; color: #ffffff !important;">mdi-triangle
                  </v-icon>
                </div>
                <div v-else style="display: flex; justify-content: space-evenly; width: 100%; align-item: center;">
                  <v-icon style="font-size: 16px; font-weight: bold; color: #858585 !important;">mdi-filter-variant
                  </v-icon>
                  <span class="mx-2">Filter</span>
                  <v-icon style="font-size: 12px; font-weight: bold; color: #858585 !important;">mdi-triangle
                    {{!showStatusOutView ? 'mdi-rotate-180' : ''}}
                  </v-icon>
                </div>
              </v-btn>
              <v-card style="max-width: 200px !important" light class="fix sae-dropdown mt-2" v-if="showStatusOutView">
                <v-treeview style="margin-left: -20px;" absolute :items="statusOut" open-all transition
                  :search="searchOutByTree" selection-type="independent" v-model="selectedOut" item-key="value">
                  <template v-slot:label="{ item, selected }">
                    <div>
                      <v-icon :color='selected ? "#82b1ff" : ""' style="cursor: pointer;" class="mr-2"
                        @click="checkSearchStatusOut(item.value)">{{
                      selected ? "mdi-checkbox-marked" : "mdi-checkbox-blank-outline"
                    }}</v-icon>
                      <span>{{ item.name }}</span>
                    </div>
                  </template>
                </v-treeview>
              </v-card>
            </v-col>
            <v-col>
              <v-btn class="px-4 py-3" outlined style="border: 1px solid #C4C4C4; height: 48px;"
                :disabled="loadingDownload" @click="downloadTracking">
                <v-row class="ma-0" style="align-items: center; justify-content: space-evenly;">
                  <v-col class="pa-0 ma-0">
                    <v-icon color="#C4C4C4">mdi-download</v-icon>
                  </v-col>
                  <v-col class="pa-0 ml-1 ma-0">
                    <b style="text-transform: none;">Download Data</b>
                  </v-col>
                </v-row>
              </v-btn>
            </v-col>
          </v-row>
          <v-divider class="mx-3 my-6"></v-divider>
          <v-row class="ml-1 mr-1" style="align-items: center; justify-content: center;">
            <v-col v-if="inarea == 'all' | inarea == 'inarea' " :md="inarea == 'inarea' ? 12 : 6" class="px-6 mb-4">
              <v-row>
                <v-col md="12"
                  style="border-radius: 12px; background: rgb(25, 118, 210, 0.1); color: rgb(25, 118, 210)">
                  <center>
                    In Area
                    <br>
                    <h1 style="font-size: 48px">
                      {{areaIn}}
                    </h1>
                  </center>
                </v-col>
              </v-row>
            </v-col>
            <v-col v-if="inarea == 'all' | inarea == 'outarea' " :md="inarea == 'outarea' ? 12 : 6" class="px-6 mb-4">
              <v-row>
                <v-col md="12" style="border-radius: 12px; background: rgb(230, 74, 77, 0.1); color: rgb(230, 74, 77)">
                  <center>
                    Out of Area
                    <br>
                    <h1 style="font-size: 48px">
                      {{areaOut}}
                    </h1>
                  </center>
                </v-col>
              </v-row>
            </v-col>
            <v-col md="12" style="max-height: 35vh;" class="overflow-y-auto">
              <v-timeline align-top dense>
                <v-timeline-item v-for="(n, index) in timeline" :key="index"
                  :color="countDistance(n) ? `#CDCDCD` : `#E64A4D`" small>
                  <v-row class="pt-1">
                    <v-col cols="12">
                      <strong>{{milisToHour(n.timestamp)}} {{checkTimeZone(n.timezone)}} <span v-if="index == 0">(Check
                          In)</span> <img v-if="!countDistance(n)" style="margin-left: 8px; vertical-align: middle;"
                          src="/img/warning.svg"></strong>
                    </v-col>
                    <v-col cols="12">
                      <div v-if="index == 0" class="text-caption">
                        {{countDistance(n) ? 'In Area' : 'Out of Area'}} ({{tempGeometry}})
                      </div>
                      <div v-else class="text-caption">
                        {{countDistance(n) ? 'In Area' : 'Out of Area'}} ({{n.latitude +','+ n.longitude}})
                      </div>
                    </v-col>
                  </v-row>
                </v-timeline-item>
              </v-timeline>
            </v-col>
          </v-row>
        </div>
        <div v-if="user_full_detail && !userBeing && noTracking">
          <v-row class="pa-10 pb-4">
            <img @click="backtoGroup()" style="margin-right: 19px; cursor: pointer;"
              src="/img/vector-arrow-left.svg"><b>Employee Details</b>
          </v-row>
          <v-row class="pl-10 py-3" style="align-items: center;">
            <div class="v-avatar ml-1" style="height: 60px; min-width: 60px; width: 60px;">
              <img v-if="user_full_detail.avatar_url" :src="user_full_detail.avatar_url" alt="Avatar">
              <img v-else src="/img/neutral.png">
            </div>
            <div class="ml-4"
              style="font-size: 16px; font-weight: bold; line-height: 26px; letter-spacing: 0px; color:#background: #040404;">
              {{user_full_detail.full_name}}
              <br>
              <span
                style="font-family: Noto Sans; font-size: 14px; font-weight: 400; line-height: 23px; letter-spacing: 0px; color: #686868;">
                {{user_full_detail.job_position}}</span>
            </div>
          </v-row>
          <v-row class="px-10 py-5">
             <v-divider></v-divider>
          </v-row>
           <v-row class="px-10 pt-2 pb-10">
           <div style="width: 100%; background: rgba(130, 130, 130, 0.1); border-radius: 12px; height: 52px;">
             <v-row class="pa-0 ma-0" style="height: 100%; width: 100%; font-weight: 600; font-size: 14px; color: #828282; text-align: center;" justify="center" align="center">
             This user doesn’t activate live tracking feature.
             </v-row>
           </div>
          </v-row>
        </div>
      </v-card>
    </div>

  </div>
</template>
<script>
  import axios from "axios";
  import moment from "moment";
  import mt from "moment-timezone";
  import _ from 'lodash'
  import * as geolib from 'geolib';

  // import AnimateNumber from './components/AnimateNumber'

  export default {
    name: "summaryCombined",
    data() {
      return {
        analytics: null,
        destroyer: null,
        counter: 0,
        areaIn: 0,
        areaOut: 0,
        inarea: 'all',
        markerArea: true,
        noTracking: false,
        findUserButton: false,
        selectType: null,
        selectedScheduleType: null,
        loadingTrack: false,
        shiftList: [{
            id: 1,
            name: this.$i18n.t('regular'),
            value: 'regular'
          },
          {
            id: 2,
            name: this.$i18n.t('shift'),
            value: 'shift'
          },
        ],
        statusIn: [{
            id: 0,
            value: 'All',
            name: this.$i18n.t('all')
          },
          {
            id: 1,
            value: 'On-Time',
            name: this.$i18n.t('on-time')
          },
          {
            id: 2,
            value: 'In-Tolerance',
            name: this.$i18n.t('in_tolerance')
          },
          {
            id: 3,
            value: 'Others',
            name: this.$i18n.t('others')
          },
          {
            id: 4,
            value: 'Meeting',
            name: this.$i18n.t('meeting')
          },
          {
            id: 5,
            value: 'Edited',
            name: this.$i18n.t('edited')
          },
          {
            id: 6,
            value: 'Incident',
            name: this.$i18n.t('incident')
          },
        ],
        statusOut: [{
            id: 0,
            value: 'All',
            name: this.$i18n.t('all')
          }, {
            id: 1,
            value: 'In-Area',
            name: this.$i18n.t('in-area')
          },
          {
            id: 2,
            value: 'Out-Of-Area',
            name: this.$i18n.t('out-of-area')
          },
        ],
        attendanceList: [{
            id: 0,
            value: 'All',
            name: this.$i18n.t('all')
          }, {
            id: 1,
            name: 'dayoff',
            value: 'dayoff'
          },
          {
            id: 2,
            name: 'present',
            value: 'checkout'
          },
          {
            id: 3,
            name: 'checkoutbysystem',
            value: 'checkoutbysystem'
          },
          {
            id: 4,
            name: 'leave',
            value: 'leave'
          },
          {
            id: 5,
            name: 'corrected',
            value: 'corrected'
          },
          {
            id: 6,
            name: 'absent',
            value: 'absent'
          },
          {
            id: 7,
            name: 'national_holiday',
            value: 'nasional_holiday'
          },
          // {
          //   id: 8,
          //   name: 'others',
          //   value: 'others'
          // },
          // {
          //   id: 9,
          //   name: 'overtime',
          //   value: 'overtime'
          // },
          {
            id: 10,
            name: 'checkin',
            value: 'checkin'
          },
          {
            id: 11,
            name: 'corporate_holiday',
            value: 'corporate_holiday'
          },
        ],
        loadingDownload: false,
        valid: false,
        rules: [(value) => !!value || "Required."],
        disableChooseGroupDownloadMonthly: false,
        downloadMonthlyDialog: false,
        minDate: '',
        maxDate: '',
        allowedDate: [],
        currentDate: '',
        stillRunning: false,
        selectedUser: {},
        supervisorGroup: [],
        tempUserList: [],
        userList: [],
        placeList: [],
        searchGroupsByTree: '',
        searchZoneByTree: '',
        searchOutByTree: '',
        searchInByTree: '',
        searchTypeByTree: '',
        searchAttendanceByTree: '',
        loadingTreeView: false,
        showTreeView: false,
        showZoneView: false,
        showStatusInView: false,
        showStatusOutView: false,
        showAttendanceView: false,
        showTypeView: false,
        overlay: false,
        selectedGroups: "",
        selectedZone: [],
        allZone: [],
        selectedIn: [],
        allIn: [],
        selectedOut: [],
        allOut: [],
        selectedStatus: [],
        allStatus: [],
        selectedType: [],
        newSelectedType: [],
        selectedAttendance: [],
        alert: {
          show: false,
          text: null,
          mode: null
        },
        gallery: {
          file: [''],
          index: null
        },
        baseUrl: this.$store.state.baseUrl,
        reportUrl: this.$store.state.reportUrl,
        holidayList: [],
        date: new Date().toISOString().substr(0, 10),
        menuStart: false,
        menuEnd: false,
        searchRaw: '',
        search: '',
        totalData: 0,
        page: 1,
        itemPerPage: 10,
        headers: [{
            text: this.$i18n.t('date'),
            value: "date",
            width: "10%"
          },
          {
            text: this.$i18n.t('employee_name'),
            value: "full_name",
            width: "20%"
          },
          {
            text: this.$i18n.t('time_in'),
            value: "time_in"
          },
          {
            text: this.$i18n.t('status_in'),
            value: "reason_in"
          },
          {
            text: this.$i18n.t('location_in'),
            value: "note_in"
          },
          {
            text: this.$i18n.t('time_out'),
            value: "time_out"
          },
          {
            text: this.$i18n.t('status_out'),
            value: "reason_out"
          },
          {
            text: this.$i18n.t('status'),
            value: "status",
            width: "10%"
          },
          {
            text: this.$i18n.t('workhour'),
            value: "workhour"
          },
          {
            text: this.$i18n.t('action'),
            value: "details"
          },
        ],
        companyId: this.$store.state.company,
        groupId: this.$store.state.group_id,
        startDate: '',
        endDate: '',
        partial: false,
        loading: true,
        userBeing: '',
        attendances: [],
        tempAttendances: [],
        dialog: false,
        detailsDialog: false,
        userDetail: [],
        loadingDetails: true,
        markers: [],
        userId: null,
        analyticsSummary: {
          on_time: 0,
          tolerance_time: 0,
          late: 0,
          on_location: 0,
          tolerance_location: 0,
          out_of_location: 0,
          correction_location: 0,
          correction_time: 0
        },
        summary: {
          on_time: 0,
          tolerance_time: 0,
          late: 0,
          on_location: 0,
          tolerance_location: 0,
          out_of_location: 0,
          is_shifting: 1
        },
        info_options: {
          pixelOffset: {
            width: 0,
            height: -35,
          },
        },
        info_position: null,
        info_opened: false,
        info_content: null,
        groupList: [],
        outList: [],
        inList: [],
        attList: [],
        groupListDownload: [],
        searchGroups: '',
        searchZones: '',
        searchIn: '',
        searchOut: '',
        searchStatus: '',
        role: null,
        filterToggler: false,
        colorToggler: '',
        feature_temperature_enabled: false,
        scheduleShift: null,
        firstload: true,
        staffListTmp: [],
        companyLiveID: '',
        validator: this.$store.state.validator,
        company_id: this.$store.state.company,
        showFilter: false,
        places: null,
        center: {
          lat: -6.1753924,
          lng: 106.8249641
        },
        markersCircle: [],
        zoom: 17,
        info_marker: null,

        info_current_key: null,

        filterTime: "",
        filterZone: "",
        filterPlace: "",
        filterGroup: "",
        filterDate: "",
        search_string: "",
        beforeDate: moment().format("DD-MM-YYYY"),
        countOntime: 0,
        countInTolerance: 0,
        countOnLate: 0,
        addItem: {
          id: "",
          zonename: "",
          address_zone: "",
          lat_zone: "",
          lng_zone: "",
          radius: "",
          companyId: "",
        },
        timeList: [{
            name: this.$i18n.t('all_time'),
            value: ""
          },
          {
            name: this.$i18n.t('on_time'),
            value: "On-Time"
          },
          {
            name: this.$i18n.t('in_tolerance'),
            value: "In-Tolerance"
          },
          {
            name: this.$i18n.t('late'),
            value: "late"
          },
        ],
        zoneList: [{
            name: this.$i18n.t('all_area'),
            value: ""
          },
          {
            name: this.$i18n.t('in_zone'),
            value: "inzone"
          },
          {
            name: this.$i18n.t('out_zone'),
            value: "outzone"
          },
        ],
        staffListInit: [],
        staffList: [],
        staffFilteredList: [],
        timeline: [],
        isHistoryClick: false,
        menuStartDate: false,
        menuEndPeriode: false,
        menuStartPeriode: false,
        user_late: 0,
        user_intolerance: 0,
        user_ontime: 0,
        marker: null,
        loadingGetAddress: false,
        tempGeometry: '',
        user_full_detail: '',
        mapStyle: [{
          featureType: "poi",
          stylers: [{
            visibility: "off"
          }],
        }, ],
        periodeStart: "",
        periodeEnd: "",
        index: null,
        images: [],
        user_id: this.$store.state.user.id,
        new_data: [],
        downloadMonthlyData: {
          companyId: this.$store.state.company,
          groupId: null,
          month: null,
          year: null,
        },
      };
    },
    methods: {
      backtoGroup() {
        this.userBeing = ''
        this.noTracking = false
        this.markersCircle = []
      },
      countDistance(foo) {
        const arrayDistance = []
        for (var i in this.markersCircle) {
          var distance = geolib.isPointWithinRadius({
              latitude: foo.latitude,
              longitude: foo.longitude
            }, {
              latitude: this.markersCircle[i].lat_zone,
              longitude: this.markersCircle[i].lng_zone,
            },
            this.markersCircle[i].radius
          );

          if (distance === true) {
            arrayDistance.push(true)
          }

        }
        if (arrayDistance.length >= 1) {
          return true
        }
      },
      onCloseIW() {
        this.info_opened = false;
        this.isHistoryClick = false;
        this.search_string = "";
      },
      countInArea() {
        for (var foo in this.timeline) {
          const arrayDistance = []
          for (var i in this.markersCircle) {
            var distance = geolib.isPointWithinRadius({
                latitude: this.timeline[foo].latitude,
                longitude: this.timeline[foo].longitude
              }, {
                latitude: this.markersCircle[i].lat_zone,
                longitude: this.markersCircle[i].lng_zone,
              },
              this.markersCircle[i].radius
            );

            if (distance === true) {
              arrayDistance.push(true)
            }

          }
          if (arrayDistance.length > 0) {
            this.areaIn++
          } else {
            this.areaOut++
          }
        }
      },
      countOutArea(foo) {
        let count1 = 0;
        for (var i in foo) {
          if (foo[i].location_area === false) {
            count1++;
          }
        }
        return count1
      },
      async fetchGroup() {
        const result = await this.$store.dispatch('getGroupByCompany', {
          companyId: this.company_id
        })
        this.groupList = [];
        result.forEach((row) => {
          let groupList = {};
          groupList.name = row.alias;
          groupList.value = row.id;

          this.groupList.push(groupList);

        })
      },
      async fetchUserDetails(user_id) {
        const result = await this.$store.dispatch('getEmployeeDetail', {
          user_id
        })
        this.user_full_detail = result;
        this.markersCircle = result.group.zones
      },
      async findTrackingUser(foo) {
        this.userId = foo.id
        await this.getLiveTracking()
        await this.fetchUserDetails(foo.id)
        this.info_opened = false;
        this.isHistoryClick = false;
        this.search_string = "";

      },
      async getAddress(lat, lng) {
        if (lat && lng) {
          this.loadingGetAddress = true
          const result = await this.$store.dispatch('getAddressMaps', {
            latlng: `${lat},${lng}`,
            key: 'AIzaSyAdfU8LnR3fHg7oPVo_mSeUIFjI64Af3YI'
          })
          setTimeout(() => {
            this.loadingGetAddress = false
          }, 3000);

          if (result.results.length > 0) {
            this.tempGeometry = result.results[0].formatted_address
          }
        }
      },
      async getLiveTracking() {
        this.areaIn = 0
        this.areaOut = 0
        this.findUserButton = true
        this.userBeing = ''
        this.timeline = ''
        this.noTracking = false
        const dateLiveTracking = moment(this.startDate).format('DD-MM-YYYY')
        const url =
          `${this.reportUrl}/usertrack/report?companyId=${this.companyId}&startDate=${dateLiveTracking}&endDate=${dateLiveTracking}&userId=${this.userId}`;
        axios.get(url, {
          headers: {
            action: "Get Live Tracking",
            actionId: 4
          }
        }).then((res) => {
          if (res.data.data.records.length > 0) {
            this.userBeing = res.data;
            this.center.lat = res.data.data.records[0].data_live_trackings[0].latitude
            this.center.lng = res.data.data.records[0].data_live_trackings[0].longitude
            this.timeline = res.data.data.records[0].data_live_trackings
            if (res.data.data.records[0].data_live_trackings) {
              this.countInArea()
            }
            if (res.data.data.records[0].data_live_trackings[0].latitude && res.data.data.records[0].data_live_trackings[0]
              .longitude) {

              this.getAddress(res.data.data.records[0].data_live_trackings[0].latitude, res.data.data.records[0]
                .data_live_trackings[0].longitude)
            }
            this.findUserButton = false
            this.noTracking = false
          } else {
            this.noTracking = true
            this.markersCircle = []
            this.findUserButton = false
          }
        });
      },
      async downloadTracking() {
        this.loadingDownload = true
        const dateLiveTracking = moment(this.startDate).format('DD-MM-YYYY')
        const url =
          `companyId=${this.companyId}&date=${dateLiveTracking}&userId=${this.userId}`;

        await this.$store.dispatch('downloadLiveTracking', url)
        this.loadingDownload = false
      },
      async filterAttendanceByScheduleType(type) {
        this.page = 1;
        this.selectedScheduleType = type;
        if (type == 0) {
          this.partial = true;
          this.selectType = null;
        } else if (type == 1) {
          this.partial = true;
          this.selectType = true;
        } else {
          this.partial = false;
          this.selectType = null;
        }
        this.resetSummary();
        this.tempAttendances = await this.getDataForAdmin(this.companyId, this.startDate, this.endDate, this
          .searchGroups, this.selectType, this.itemPerPage, this.page, this.userId, this.searchZones,
          this.searchIn,
          this.searchOut, this.searchStatus)
        this.attendances = [].concat(this.tempAttendances)
        this.sumData(this.analytics)
        if (this.search.length > 0) {
          this.calculateFilteredSummary(this.attendances, this.selectedUser)
        } else {
          this.calculateGeneralSummary(this.attendances)
        }
      },
      toggleDropdown(bool) {
        if (bool) {
          this.counter = 0
          this.showTreeView = bool
        } else {
          if (this.counter > 0) {
            setTimeout(() => {
              this.showTreeView = bool
            }, 200);
          } else {
            this.counter++
          }
        }
      },
      generateYearList() {
        const createdAt = this.$store.getters.companyDetail.createdAt
        const todayYear = moment(createdAt).set({
          'year': new Date().getFullYear()
        })
        const data = moment(todayYear).diff(createdAt, 'year')
        const result = []
        for (let i = 0; i <= data; i++) {
          result.push(moment(todayYear).subtract(i, 'year').format('YYYY'))
        }
        return result
      },
      openDownloadMonthlyDialog() {
        this.downloadMonthlyDialog = true
      },
      getLimitDate(date) {
        this.minDate = moment(date).subtract(99, 'days').format('YYYY-MM-DD')
        this.maxDate = moment(date).add(99, 'days').format('YYYY-MM-DD')
      },
      checkLimitDate() {
        const start = moment(this.startDate)
        const end = moment(this.endDate)
        const diff = start.diff(end, 'days')
        if (diff < 100 && diff > -100) {
          return false
        } else {
          this.showMessage('warning', 'Max 100 days only')
          return true
        }
      },
      checkStillRunning() {
        setTimeout(() => {
          this.stillRunning = false
        }, 100)
      },
      checkStatusTime(key, note) {
        const lowerKey = key.toLowerCase()
        if ((lowerKey == 'absent') && (note == '' || note == '-' || note == null)) {
          return false
        } else if (lowerKey == 'day-off' || lowerKey == 'dayoff') {
          return this.$i18n.t('dayoff')
        } else {
          return this.$i18n.t(note.toLowerCase())
        }
        // switch (key.toLowerCase()) {
        //   case (key == 'absent' && (note != '' || note != '-')):
        //     return this.$i18n.t('absent')
        //   case 'day-off':
        //   case 'dayoff':
        //     return this.$i18n.t('dayoff')
        //   default:
        //     return this.$i18n.t(note.toLowerCase())
        // }
      },
      noShift() {
        if (this.analyticsSummary.is_shifting != 0) {
          return 1
        } else {
          return ""
        }
      },
      noShift2() {
        if (this.analyticsSummary.is_shifting != 0) {
          return "ml-5"
        } else {
          return ""
        }
      },
      noShift3() {
        if (this.analyticsSummary.is_shifting != 0) {
          return "3"
        } else {
          return "6"
        }
      },
      checkStatusIn(key, note) {
        const lowerKey = key.toLowerCase()
        if ((lowerKey == 'absent') && (note === '' || note === '-' || note === null)) {
          return false
        } else if (lowerKey == 'day-off' || lowerKey == 'dayoff') {
          return false
        } else {
          return true
        }
        // switch (key.toLowerCase()) {
        //  case ((key == 'absent') && (note === '' || note === '-' || note === null)):
        //   case 'day-off':
        //   case 'dayoff':
        //     return false
        //   default:
        //     return true
        // }
      },
      checkStatusOut(key) {
        switch (key.toLowerCase()) {
          case 'checkoutbysystem':
          case 'checkin':
          case 'absent':
          case 'day-off':
          case 'dayoff':
            return false
          default:
            return true
        }
      },
      checkReason(key) {
        switch (key) {
          case null:
          case '-':
          case '':
            return false
          default:
            return true
        }
      },
      showMessage(mode, text) {
        this.alert.mode = mode
        this.alert.text = text
        this.alert.show = true
      },
      checkScheduleType(type) {
        const isExist = this.newSelectedType.indexOf(type)
        if (isExist > -1) {
          this.newSelectedType.splice(isExist, 1)
        } else {
          this.newSelectedType.push(type)
        }

      },
      checkSearchValue(groupId) {
        
        const isExist = this.selectedGroups.indexOf(groupId)
        if (isExist > -1) {
          this.selectedGroups.splice(isExist, 1)
        } else {
          this.selectedGroups.push(groupId)
        }
      },
      checkSearchZone(zoneId) {
        const isExist = this.selectedZone.indexOf(zoneId)
        const found = this.selectedZone.some(item => item === 'All' || item === 'Semua');
        if (zoneId == 'All' || zoneId == 'Semua') {
          this.selectedZone = []
          this.placeList.forEach((row) => {
            this.selectedZone.push(row.name);
          })

          if (isExist > -1) {
            this.selectedZone = []
          }
        } else {
          if (isExist > -1) {
            if (found) {
              const newAll = this.selectedZone.indexOf('All' || 'Semua')
              this.selectedZone.splice(newAll, 1)
              this.selectedZone.splice(isExist - 1, 1)
            } else {
              this.selectedZone.splice(isExist, 1)
            }

          } else {
            if (this.placeList.length - 1 == this.selectedZone.length + 1) {
              this.selectedZone.unshift('All')
              this.selectedZone.push(zoneId.toString())
            } else {
              this.selectedZone.push(zoneId.toString())
            }
          }
        }
      },
      checkSearchStatusIn(statusIn) {
        const isExist = this.selectedIn.indexOf(statusIn)
        const found = this.selectedIn.some(item => item === 'All' || item === 'Semua');
        if (statusIn == 'All' || statusIn == 'Semua') {
          this.selectedIn = []
          this.statusIn.forEach((row) => {
            this.selectedIn.push(row.value);
          })
          if (isExist > -1) {
            this.selectedIn = []
          }
        } else {
          if (isExist > -1) {
            if (found) {
              const newAll = this.selectedIn.indexOf('All' || 'Semua')
              this.selectedIn.splice(newAll, 1)
              this.selectedIn.splice(isExist - 1, 1)
            } else {
              this.selectedIn.splice(isExist, 1)
            }

          } else {
            if (this.statusIn.length - 1 == this.selectedIn.length + 1) {
              this.selectedIn.unshift('All')
              this.selectedIn.push(statusIn)
            } else {
              this.selectedIn.push(statusIn)
            }
          }
        }
      },
      checkFilter() {
        const all = this.selectedOut.some(item => item === 'All' || item === 'Semua')
        const inarea = this.selectedOut.some(item => item === 'In-Area')
        const outarea = this.selectedOut.some(item => item === 'Out-Of-Area')
        if (all || null || '') {
          this.inarea = 'all'
        } else if (inarea) {
          this.inarea = 'inarea'
        } else if (outarea) {
          this.inarea = 'outarea'
        }
        // eslint-disable-next-line no-console
        // console.log(this.inarea, 'inarea')
      },
      checkSearchStatusOut(statusOut) {
        const isExist = this.selectedOut.indexOf(statusOut)
        const found = this.selectedOut.some(item => item === 'All' || item === 'Semua');
        if (statusOut == 'All' || statusOut == 'Semua') {
          this.selectedOut = []
          this.statusOut.forEach((row) => {
            this.selectedOut.push(row.value);
            this.checkFilter()
          })
          if (isExist > -1) {
            this.selectedOut = []
            this.checkFilter()
          }
        } else {
          if (isExist > -1) {
            if (found) {
              const newAll = this.selectedOut.indexOf('All' || 'Semua')
              this.selectedOut.splice(newAll, 1)
              this.checkFilter()

              this.selectedOut.splice(isExist - 1, 1)
            } else {
              this.selectedOut.splice(isExist, 1)
              this.checkFilter()
            }

          } else {
            if (this.statusOut.length - 1 == this.selectedOut.length + 1) {
              this.selectedOut.unshift('All')
              this.checkFilter()
              this.selectedOut.push(statusOut)
            } else {
              this.selectedOut.push(statusOut)
              this.checkFilter()
            }
          }
        }
      },
      checkSearchStatus(status) {
        const isExist = this.selectedStatus.indexOf(status)
        const found = this.selectedStatus.some(item => item === 'All' || item === 'Semua');
        if (status == 'All' || status == 'Semua') {
          this.selectedStatus = []
          this.attendanceList.forEach((row) => {
            this.selectedStatus.push(row.value);
          })
          if (isExist > -1) {
            this.selectedStatus = []
          }
        } else {
          if (isExist > -1) {
            if (found) {
              const newAll = this.selectedStatus.indexOf('All' || 'Semua')
              this.selectedStatus.splice(newAll, 1)
              this.selectedStatus.splice(isExist - 1, 1)
            } else {
              this.selectedStatus.splice(isExist, 1)
            }

          } else {
            if (this.attendanceList.length - 1 == this.selectedStatus.length + 1) {
              this.selectedStatus.unshift('All')
              this.selectedStatus.push(status)
            } else {
              this.selectedStatus.push(status)
            }
          }
        }
      },
      getDownloadName() {
        const companyName = this.$store.state.companyName
        const date = moment().format('DDMMYYYYhhMM')
        return `Report ${companyName} - ${date}.xls`
      },
      getColorByTemp(temp) {
        switch (true) {
          case (temp > 0 && temp <= 37.5):
            return 'green'

          case (temp > 37.5 && temp <= 39.5):
            return 'orange'
          case (temp > 39.5):
            return 'red'
          default:
            return 'grey'
        }
      },
      openGallery(url) {
        this.gallery.file = [url]
        this.gallery.index = 0
      },
      getGlobalConfig() {
        this.feature_temperature_enabled = this.$store.getters.gcGetData('feature_health_check',
            'is_enabled') ? true :
          false
      },
      close() {
        this.dialog = false;
      },
      openDetailsDialog(item) {
        this.showTreeView = false
        this.loadingDetails = true;
        this.userDetail = item;
        const data = this.userList.find(user => {
          if (user.id == item.userId) return user
        })
        if (data) this.userDetail.shifting = data.is_shifted
        this.detailsDialog = true;
      },
      stringToLatLng(lat, lng) {
        let coordinates = {
          lat: parseFloat(lat),
          lng: parseFloat(lng),
        };
        return coordinates;
      },
      toggleInfo(data, key, marker) {
        this.markerArea = marker
        this.info_timestamp = data.timestamp
        this.info_position = {
          lat: data.latitude,
          lng: data.longitude
        };
        if (this.info_current_key == key) {
          this.info_opened = !this.info_opened;
        } else {
          this.info_opened = true;
          this.info_current_key = key;
        }

      },
      toggleInfoOut(index, key) {
        this.info_position = this.stringToLatLng(index.lat_out, index.lng_out);
        this.info_content =
          this.toHours(index.timezone_out, index.time_out) + " " + index.full_name;
        if (this.info_current_key == key) {
          this.info_opened = !this.info_opened;
        } else {
          this.info_opened = true;
          this.info_current_key = key;
        }
      },
      onStartDateChange() {
        if (this.userId) {
          this.getLiveTracking()
        }
        this.menuStart = false;
         this.info_opened = false;
        this.isHistoryClick = false;
        this.search_string = "";
      },
      onEndDateChange() {
        this.menuEnd = false;
      },
      dateFormatted(date) {
        return moment(date).locale(this.$i18n.t('lang')).format("Do MMMM YYYY");
      },
      getDayName(date) {
        return moment(date).locale(this.$i18n.t('lang')).format("dddd");
      },
      milisToHour(milis) {
        return moment(milis, "x").format("HH:mm");
      },
      countTimeSummary(reason) {
        if (reason === "-" || reason === null) {
          return;
        }
        if (reason === "On-Time") {
          this.summary.on_time += 1;
        } else {
          if (reason === "In-Tolerance") {
            this.summary.tolerance_time += 1;
          } else {
            this.summary.late += 1;
          }
        }
      },
      countLocationSummary(note) {
        if (note === "-" || note === null) {
          return;
        }
        if (note === "In-Area") {
          this.summary.on_location += 1;
        } else {
          if (note === "Meeting" || note === "Work From Home") {
            this.summary.tolerance_location += 1;
          } else {
            this.summary.out_of_location += 1;
          }
        }
      },
      getReasonColor(reason) {
        if (reason === "-" || reason === null || reason === 'Day Off') {
          return;
        }
        if (reason === "On-Time") {
          return "success";
        } else {
          if (reason === "In-Tolerance") {
            return "warning";
          } else if (reason === "Edited") {
            return "primary"
          } else {
            return "error";
          }
        }
      },
      getNoteColor(note) {
        if (note === "-" || note === null || note === 'Day Off') {
          return;
        }
        if (note === "In-Area") {
          return "success";
        } else {
          if (note === "Meeting" || note === "Work From Home") {
            return "warning";
          } else {
            return "error";
          }
        }
      },
      resetSummary() {
        this.summary = {
          on_time: 0,
          tolerance_time: 0,
          late: 0,
          on_location: 0,
          tolerance_location: 0,
          out_of_location: 0,
        };
      },
      convertDate(time) {
        let convert = time.toString().split(" ");
        let hour = convert[4];
        return hour;
      },
      toHours(zone, time) {
        if (time != undefined) {
          let utc = new Date(parseInt(time));
          let tmp = "";
          if (zone === 7) {
            tmp = mt.tz(utc, "Asia/Jakarta");
          } else if (zone === 8) {
            tmp = mt.tz(utc, "Asia/Makassar");
          } else if (zone === 9) {
            tmp = mt.tz(utc, "Asia/Jayapura");
          }
          return this.convertDate(tmp);
        }
      },
      checkTimeZone(zone) {
        if (zone === 7) {
          return 'WIB'
        } else if (zone === 8) {
          return 'WITA'
        } else if (zone === 9) {
          return 'WIT'
        }
      },
      milisToTime(milis) {
        return moment(milis, "x").format("HH:mm:ss");
      },
      milisToDate(milis) {
        return moment(milis, "x").format("DD-MM-YYYY");
      },

      async downloadSummaryReportMonthly() {
        let params = {
          companyId: this.downloadMonthlyData.companyId,
          month: this.downloadMonthlyData.month,
          year: this.downloadMonthlyData.year,
        }
        if (this.downloadMonthlyData.groupId) params.groupId = this.downloadMonthlyData.groupId
        await this.$store.dispatch('getReportDownloadSummary', params)
      },
      async newCleansing() {
        if (!this.loadingCleansing) {
          this.loadingCleansing = true
          const startDate = moment(this.startDate).format("DD-MM-YYYY");
          const endDate = moment(this.endDate).format("DD-MM-YYYY");
          const params = {
            companyId: this.companyId,
            startDate: startDate,
            endDate: endDate,
          }
          const result = await this.$store.dispatch('getReportNewCleansingShifting', params)
          this.loadingCleansing = false
          if (result) {
            this.showMessage('success', 'Data Synchronized')
            this.chooseSearch()
          }
        }
      },
      async downloadSummaryReport() {
        this.loadingDownload = true
        const startDate = moment(this.startDate).format("DD-MM-YYYY");
        const endDate = moment(this.endDate).format("DD-MM-YYYY");
        let url = `companyId=${this.companyId}&startDate=${startDate}&endDate=${endDate}`
        if (this.searchGroups) url = `${url}&groupId=${this.searchGroups}`;
        if (this.search) url = `${url}&userId=${this.selectedUser.id}`
        await this.$store.dispatch('getReportDownloadSummaryWeekly', url)
        this.loadingDownload = false
      },
      async chooseSearch() {
        this.page = 1;
        this.itemPerPage = 10;
        let groupParam = '';
        let zoneParam = '';
        let inParam = '';
        let outParam = '';
        let statusParam = '';


        if (this.newSelectedType.includes('regular') && this.newSelectedType.length === 1) {
          this.partial = true;
          this.selectType = false;
        } else if (this.newSelectedType.includes('shift') && this.newSelectedType.length === 1) {
          this.partial = true;
          this.selectType = true;
        } else if (this.newSelectedType.includes('shift') && this.newSelectedType.includes(
            'regular') && this
          .newSelectedType.length === 2) {
          this.partial = false;
          this.selectType = null;
        } else {
          this.partial = false;
          this.selectType = null;
        }

        this.selectedGroups.map((item, i) => {
          groupParam = groupParam + item
          if (i != this.selectedGroups.length - 1) {
            groupParam = groupParam + ','
          }
        })
        this.selectedZone.map((item, i) => {
          if (this.selectedZone[i] !== undefined) {
            zoneParam = zoneParam + item
          }
          if (i != this.selectedZone.length - 1 && this.selectedZone[i] !== undefined) {
            zoneParam = zoneParam + ','
          }
        })
        this.selectedIn.map((item, i) => {
          if (this.selectedIn[i] !== "All") {
            inParam = inParam + item
          }
          if (i != this.selectedIn.length - 1 && this.selectedIn[i] !== "All") {
            inParam = inParam + ','
          }
        })
        this.selectedOut.map((item, i) => {
          if (this.selectedOut[i] !== "All") {
            outParam = outParam + item
          }
          if (i != this.selectedOut.length - 1 && this.selectedOut[i] !== "All") {
            outParam = outParam + ','
          }
        })
        this.selectedStatus.map((item, i) => {
          if (this.selectedStatus[i] !== "All") {
            statusParam = statusParam + item
          }
          if (i != this.selectedStatus.length - 1 && this.selectedStatus[i] !== "All") {
            statusParam = statusParam + ','
          }
        })
        if (zoneParam != '') {
          this.searchZones = zoneParam
        }
        if (inParam != '') {
          this.searchIn = inParam
        }
        if (outParam != '') {
          this.searchOut = outParam
        }
        if (statusParam != '') {
          this.searchStatus = statusParam
        }
        if (groupParam == '') {
          if (this.role == 3 || this.role == 4) {
            this.searchGroups = this.groupId
          } else {
            this.searchGroups = groupParam
          }
        } else {
          this.searchGroups = groupParam
        }
        if (this.checkLimitDate()) return;
        this.tempAttendances = await this.getDataForAdmin(this.companyId, this.startDate, this
          .endDate, this
          .searchGroups,
          this.selectType, this.itemPerPage, this.page, this.userId, this.searchZones, this
          .searchIn,
          this.searchOut, this.searchStatus)
        this.attendances = [].concat(this.tempAttendances)
        this.sumData(this.analytics)
        if (this.search.length > 0) {
          this.calculateFilteredSummary(this.attendances, this.selectedUser)
        } else {
          this.calculateGeneralSummary(this.attendances)
        }
      },
      async getCalendarHoliday() {
        const result = await this.$store.dispatch('getHolidayByCompany', {
          companyId: this.companyId
        })
        this.holidayList = result
        this.calculateHolidayWithSummary(this.attendances)
      },
      calculateHolidayWithSummary(attendance) {
        attendance.map((item) => {
          const attendanceUser = moment(item.date, 'DD-MM-YYYY')
          this.holidayList.map((hole) => {
            const start = moment(hole.date_start, 'YYYY-MM-DD')
            const end = moment(hole.date_end, 'YYYY-MM-DD')

            const test = moment(attendanceUser).isBetween(start, end, undefined, [])
            if (test) {
              if (item.status == "absent") item.status = hole.category == 1 ?
                "Corporate Holiday" :
                "National Holiday";
              if (item.note_in == null) item.note_in = "Day Off";
              if (item.note_out == null) item.note_out = "Day Off";
              if (item.reason_in == null) item.reason_in = "Day Off";
              if (item.reason_out == null) item.reason_out = "Day Off";
              if (item.status == "corrected") item.status = "Corrected";
              if (item.status == "checkin") item.status = "Check In";
              if (item.status == "edited") item.status = "Edited";
            }
          })
        })
      },
      costumHeader(action, actionId) {
        return {
          headers: {
            action,
            actionId
          }
        }
      },
      formatDateForParams(date) {
        return moment(date).format("DD-MM-YYYY")
      },
      async getDataAttendanceAdmin(companyId, startDate, endDate, groupId, shifted, totalPageSend,
        start, userId,
        zoneId, statusIn, statusOut, status) {
        const params = {
          companyId: companyId,
          startDate: this.formatDateForParams(startDate),
          endDate: this.formatDateForParams(endDate),
          page: start,
          pageSize: totalPageSend,
        }
        if (groupId) params.groupId = groupId
        if (shifted != null) {
          params.scheduleShift = shifted
        }
        if (userId) params.userId = userId
        if (zoneId && this.selectedZone.length != 0) params.zone = zoneId
        if (statusIn && this.selectedIn.length != 0) params.status_in = statusIn
        if (statusOut && this.selectedOut.length != 0) params.status_out = statusOut
        if (status && this.selectedStatus.length != 0) params.status = status
        const result = await this.$store.dispatch('getReportAttendance', params)
        this.analytics = result
        this.totalData = result.total
        return result.records
      },
      async paginatePage(page = 1, itemPerPage = 10) {
        this.page = page;
        this.itemPerPage = itemPerPage;
        const totalPageSend = itemPerPage < 1 ? this.totalData : itemPerPage;
        const start = this.page;
        this.tempAttendances = await this.getDataForAdmin(this.companyId, this.startDate, this
          .endDate, this
          .searchGroups, this.selectType, totalPageSend, start, this.userId, this
          .searchZones, this
          .searchIn, this.searchOut, this.searchStatus)
        this.attendances = [].concat(this.tempAttendances)
        if (this.search.length > 0) {
          this.calculateFilteredSummary(this.attendances, this.selectedUser)
        } else {
          this.calculateGeneralSummary(this.attendances)
        }
      },
      getDataForAdmin(companyId, startDate, endDate, groupId, shifted, totalPageSend, start,
        userId,
        zoneId, statusIn, statusOut, status) {
        this.destroyer.cancel('Canceled')
        return new Promise(async (resolve) => {
          setTimeout(() => {
            this.loading = true
          }, 100);
          this.destroyer = axios.CancelToken.source()
          const result = await Promise.all([
            this.getDataAttendanceAdmin(companyId, startDate, endDate, groupId,
              shifted, totalPageSend, start,
              userId, zoneId, statusIn, statusOut, status),
          ])
          this.loading = false
          return resolve(this.mappingAttendance(result))
        })
      },
      mappingAttendance(data = []) {
        let result = []
        data.map(item => {
          result = result.concat(item)
        })
        return _.orderBy(result, item => {
          return moment(item.date, 'DD-MM-YYYY')
        }, 'desc')
      },
      calculateGeneralSummary(data = []) {
        this.resetSummary()
        data.map(item => {
          this.countTimeSummary(item.reason_in)
          // this.countTimeSummary(item.reason_out)
          this.countLocationSummary(item.note_in)
          // this.countLocationSummary(item.note_out)
        })
      },
      async calculateFilteredSummary(user) {
        if (user) {
          this.userId = user.id;
        } else {
          this.userId = null;
        }
        this.page = 1;
        this.itemPerPage = 10;
        this.tempAttendances = await this.getDataForAdmin(this.companyId, this.startDate,
          this.endDate, this
          .searchGroups, this.selectType, this.itemPerPage, this.page, this.userId, this
          .searchZones,
          this.searchIn,
          this.searchOut, this.searchStatus)
        this.attendances = [].concat(this.tempAttendances)
        this.sumData(this.analytics)
        //   this.selectedUser = user
        //   this.search = user.full_name
        //   this.resetSummary()
        //   data.map(item => {
        //     if (item.userId == user.id) {
        //       this.countTimeSummary(item.reason_in)
        //       this.countTimeSummary(item.reason_out)
        //       this.countLocationSummary(item.note_in)
        //       this.countLocationSummary(item.note_out)
        //     }
        //   })
        // } else {
        //   this.search = ''
        //   this.calculateGeneralSummary(data)

      },
      checkRole() {
        this.role = this.$store.state.role
        switch (parseInt(this.role)) {
          case 0:
          case 2:
          case 4:
            this.listGroupByHierarchy()
            break
          case 3:
          default:
            this.disableChooseGroupDownloadMonthly = true
            this.searchGroups = this.groupId
            this.listGroupByHierarchySupervisor()
            break
        }
      },
      mappingGroupChildren(groups) {
        let result = []
        if (groups) {
          for (let i = 0; i < groups.length; i++) {
            if (groups[i])
              if (groups[i].children)
                if (groups[i].children.length > 0) {
                  result.push(groups[i])
                  result = result.concat(this.mappingGroupChildren(groups[i].children))
                } else {
                  result.push(groups[i])
                }
          }
        }
        return result.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
      },
      async listGroupByHierarchy() {
        const result = await this.$store.dispatch('getGroupByHierarchyByCompany', {
          companyId: this.companyId
        })
        if (result.length > 0) {
          this.groupList = result
          this.groupListDownload = this.mappingGroupChildren(result)
          this.groupListDownload.unshift({
            id: null,
            name: this.$i18n.t('all')
          })
          this.userList = this.tempUserList
        } else {
          this.groupList = []
          this.groupListDownload = []
        }
      },
      async listGroupByHierarchySupervisor() {
        const result = await this.$store.dispatch('getGroupListById', {
          id: this.groupId
        })
        if (result.length > 0) {
          this.groupList = result
          this.groupListDownload = result
          const groupId = this.groupListDownload.find(e => e.id == this.groupId)
          this.downloadMonthlyData.groupId = groupId ? groupId.id : ''
          this.filterUserByRole()
        } else {
          this.groupList = []
          this.groupListDownload = []
        }
      },
      getUserList() {
        return new Promise(async resolve => {
          this.tempUserList = []
          const result = await this.$store.dispatch(
            'getEmployeeListNoPagination', {
              companyId: this.companyId
            })
          result.rows.map(user => {
            if (user.status) this.tempUserList.push(user)
          })
          setTimeout(() => {
            resolve(true)
          }, 500);
        })
      },
      filterUserByRole() {
        const userList = []
        const groupList = this.groupList.map(item => {
          return parseInt(item.id)
        })
        this.tempUserList.map(user => {
          if (groupList.indexOf(user.groupId) > -1) userList.push(user)
        })
        this.userList = userList
      },
      closeTreeView() {
        this.toggleDropdown(false)
      },
      sumData(data) {
        const sum = this.analyticsSummary
        sum.on_time = data.on_time
        sum.tolerance_time = data.in_tolerance_time
        sum.late =
          data.late_incident +
          data.late_meeting +
          data.late_others
        sum.correction_time = data.correction_time
        sum.on_location = data.in_location
        sum.tolerance_location = data.in_tolerance_location_meeting + data
          .in_tolerance_location_wfh
        sum.out_of_location = data.out_tolerance_location
        sum.correction_location = data.correction_location
        sum.is_shifting = data.is_shifting
      },
      translateMe(word) {
        const translate = word.toLowerCase()
        return this.$i18n.t(translate)
      },
      toggleFilter() {
        this.filterToggler = !this.filterToggler
        if (this.filterToggler) {
          this.colorToggler = 'primary'
        } else {
          this.colorToggler = ''
        }
      },
      showTree(filter) {
        if (filter == 'group') {
          this.showTreeView = !this.showTreeView
        } else if (filter == 'zone') {
          this.showZoneView = !this.showZoneView
        } else if (filter == 'status-in') {
          this.showStatusInView = !this.showStatusInView
        } else if (filter == 'status-out') {
          this.toggleFilter()
          this.showStatusOutView = !this.showStatusOutView
        } else if (filter == 'type') {
          this.showTypeView = !this.showTypeView
        } else if (filter == 'attendance') {
          this.showAttendanceView = !this.showAttendanceView
        }
      },
      async fetchZones() {
        this.placeList = [];
        const result = await this.$store.dispatch('getZoneMasterByCompany', {
          companyId: this.companyId
        })
        result.rows.forEach((row) => {
          if (row.zonename) {
            let placeList = {};
            placeList.name = row.zonename;
            placeList.value = row.id;
            this.placeList.push(placeList);
          }
        })
        this.placeList.unshift({
          id: 1,
          value: 'All',
          name: this.$i18n.t('all')
        })
      },
      async getGroupUsers() {
        const url = `${this.baseUrl}/user/listbygrouparray`
        try {
          const body = {
            groupsId: [this.selectedGroups.value]
          }
          const result = await axios.post(url, body, {
            headers: {
              action: 'Get User By Group Ids',
              actionId: 4
            }
          })
          if (result) {
            return result.data.data
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e)
        }
      },

    },
    async created() {
      this.destroyer = axios.CancelToken.source()
      this.startDate = moment().format('YYYY-MM-DD')
      this.endDate = moment().format('YYYY-MM-DD')
      this.yearList = this.generateYearList()
      this.getGlobalConfig()
      await this.getUserList()
      this.fetchZones()
      this.fetchGroup()
      this.currentDate = this.startDate
      this.getLimitDate(this.startDate)

    },
    watch: {
      async selectedGroups() {
        
        if (!this.stillRunning) {
          this.stillRunning = true
          this.checkStillRunning()
          this.noTracking = false
          this.userBeing = false
          if (this.selectedGroups) {
            this.userList = await this.getGroupUsers()
            this.findUserButton = false
          }
        }
      }
    },

    components: {
      // AnimateNumber
    },
    computed: {

    }
  };
</script>
<style>
  /* Hide scrollbar for Chrome, Safari and Opera */
  .group-overflow::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  .group-overflow {
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
  }

  .calendar-pointer input {
    cursor: pointer !important;
  }

  .calendar-pointer .v-input__slot {
    box-shadow: none !important;
    border: 1px solid #CDCDCD;
  }

  .v-timeline-item__dot--small {
    margin-top: 10px;
    height: 10px !important;
    width: 10px !important;
    color: #CDCDCD;
  }

  .v-timeline-item__dot--small .v-timeline-item__inner-dot {
    height: 10px !important;
    margin: 0px !important;
    width: 10px !important;
  }
</style>
<style scoped>
  .container-filter {
    position: absolute;
    left: 0;
    top: 50px;
    width: 275px;
  }

  .container-summary {
    position: absolute;
    left: 0px;
    top: 105px;
    width: 350px;
  }

  .container-content {
    position: absolute;
    right: 0px;
    top: 105px;
    width: 350px;
    height: calc(100vh - 135px);
  }

  .content-card {
    font-size: 12px;
    height: calc(100vh - 135px);
  }

  .filter-card {
    position: absolute;
    top: 80px;
    left: 20px;
    width: 100%;
    justify-content: center;
  }


  .tiny-text {
    font-size: 9px;
    font-weight: bold;
  }

  .color-primary {
    color: #033b6d;
  }

  .bg-primary {
    background-color: #033b6d;
  }

  .label-summary {
    font-size: 0.7em;
  }

  .in-area-circle-true {
    height: 16px;
    width: 16px;
    background-color: #1976D2;
    border-radius: 50%;
    display: inline-block;
  }

  .in-area-circle-false {
    height: 16px;
    width: 16px;
    background-color: #E64A4D;
    border-radius: 50%;
    display: inline-block;
  }
</style>